// Paid AI image generation (OpenAI concepts, Gemini AI render) is switched off for now.
export const AI_GENERATION = false;
